const CT_EMPLOYMENT_REFERENCE = 'CT_EMPLOYMENT_REFERENCE'
const NJ_EMPLOYMENT_REFERENCE = 'NJ_EMPLOYMENT_REFERENCE'
const MI_EMPLOYMENT_REFERENCE = 'MI_EMPLOYMENT_REFERENCE'
const OR_EMPLOYMENT_REFERENCE = 'OR_EMPLOYMENT_REFERENCE'
const CA_EMPLOYMENT_REFERENCE = 'CA_EMPLOYMENT_REFERENCE'
const PA_EMPLOYMENT_REFERENCE = 'PA_EMPLOYMENT_REFERENCE'
const UT_EMPLOYMENT_REFERENCE = 'UT_EMPLOYMENT_REFERENCE'
const DC_EMPLOYMENT_REFERENCE = 'DC_EMPLOYMENT_REFERENCE'
const AZ_EMPLOYMENT_REFERENCE = 'AZ_EMPLOYMENT_REFERENCE'
const NM_EMPLOYMENT_REFERENCE = 'NM_EMPLOYMENT_REFERENCE'

export const formTypes = {
  CT_EMPLOYMENT_REFERENCE,
  NJ_EMPLOYMENT_REFERENCE,
  MI_EMPLOYMENT_REFERENCE,
  OR_EMPLOYMENT_REFERENCE,
  CA_EMPLOYMENT_REFERENCE,
  PA_EMPLOYMENT_REFERENCE,
  UT_EMPLOYMENT_REFERENCE,
  DC_EMPLOYMENT_REFERENCE,
  AZ_EMPLOYMENT_REFERENCE,
  NM_EMPLOYMENT_REFERENCE,
}
